import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'proxyType' })

export class ProxyTypePipe implements PipeTransform {
    transform(data: any, note: string) {
        if (data == null) return null;

        var ParentTypes = [
            { ID: 1, Description: 'Mother', RequiresNote: false }, { ID: 2, Description: 'Father', RequiresNote: false }, { ID: 3, Description: 'Guardian', RequiresNote: false }, { ID: 4, Description: 'Other', RequiresNote: true }
        ];

        for (var i = 0, j = ParentTypes.length; i < j; ++i) {
            if (ParentTypes[i].ID == data) {
                if (ParentTypes[i].RequiresNote == false) return ParentTypes[i].Description;
                if (note == null || note == '') return 'Other - Unspecified';
                return 'Other - ' + note;
            }
        }

        return data;
    }
}


